import React from "react";
import { ButtonControls } from "./buttonControls";
import { Form } from "react-bootstrap";
import { groupTypes } from "../utils/consts";
import { ModalEditItem } from "./modalEditItem/modal";
import "../../../../../assets/css/revised_css/lang-editor.css"
export function MultiSelectDisplay({
  displaySettings, 
  label, 
  buttonControlsProps,
  changed,
  value,
  options,
  setShowEditItem,
  showEditItem, 
  name,
  idx
}){
  const {as, ...displaySettingsRest} = displaySettings

  return(
    <Form.Group as={groupTypes[as]} {...displaySettingsRest} >
      <Form.Label>{label}</Form.Label>
      <ButtonControls {...buttonControlsProps} idx={idx} value={value}/>
      <Form.Control className="lang-editor-multiselect" idx={idx} as="select" multiple value={[value]} onChange={changed}>
        {options}
      </Form.Control>
      <ModalEditItem idx={idx} name={name} show={showEditItem} setShow={setShowEditItem}/>
    </Form.Group>
  )
}